import { Styles } from '@gv/triage-components';
import { css, createGlobalStyle } from 'styled-components';

const { heading2 } = Styles.Font;

export const MainGlobalStyles = createGlobalStyle`
    .title {
        ${({ theme }) =>
          theme.responsive.isMobile
            ? heading2
            : css`
                font-size: 40px;
                font-weight: 700;
                line-height: 56px;
              `}
    }
`;
